import parseJwt from '../plugins/functions';
import AuthService from '../services/auth.service';

const apiToken = localStorage.getItem('yup_chat_token');

const auth = {
  namespaced: true,
  state: {
    token: apiToken,
    preferred_tfa: null,
    user: apiToken ? parseJwt(apiToken).sub : null,
  },
  actions: {
    login({ commit }, data) {
      return AuthService.login(data).then(
        (token) => {
          commit('loginSuccess', token);
          return Promise.resolve(token);
        },
        (error) => {
          commit('loginFailure');
          if (error.response) {
            return Promise.reject(error.response.data);
          }
          error.message = `${error.message}. Entre em contato com o suporte`;
          return Promise.reject(error);
        },
      );
    },
    getPreferredTwoFactor({ commit }, query) {
      return this._vm.$api.auth.getPreferredTwoFactor(query).then(
        (response) => {
          commit('setPreferredTFA', response);
          Promise.resolve(response);
        },
        (error) => Promise.reject(error.response.data),
      );
    },
    loginWithGoogle({ commit }, data) {
      return this._vm.$api.auth.loginWithGoogle(data).then(
        (response) => {
          commit('loginSuccess', response.token);
          return Promise.resolve(response.token);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        },
      );
    },
    loginWithFacebook({ commit }, data) {
      return this._vm.$api.auth.loginWithFacebook(data).then(
        (response) => {
          commit('loginSuccess', response.token);
          return Promise.resolve(response.token);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        },
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, data) {
      return AuthService.register(data).then(
        (token) => Promise.resolve(token),
        (error) => {
          commit('registerFailure');
          return Promise.reject(error);
        },
      );
    },
    registerTrial({ commit }, data) {
      return AuthService.registerTrial(data).then(
        (token) => Promise.resolve(token),
        (error) => {
          commit('registerFailure');
          return Promise.reject(error);
        },
      );
    },
    reset({ commit }, data) {
      return AuthService.reset(data).then(
        () => Promise.resolve(),
        (error) => Promise.reject(error),
      );
    },
    resetVerification({ commit }, token) {
      return AuthService.resetVerification(token).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error),
      );
    },
    resetPassword({ commit }, data) {
      return AuthService.resetPassword(data).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error),
      );
    },
    refresh({ commit }) {
      return AuthService.refresh().then(
        (token) => {
          commit('refreshToken', token);
          return Promise.resolve(token);
        },
        (error) => {
          AuthService.logout();
          commit('logout');
          return Promise.reject(error);
        },
      );
    },
  },
  mutations: {
    loginSuccess(state, token) {
      // state.status.loggedIn = true;
      state.token = token;
      state.user = parseJwt(token).sub;
    },
    setPreferredTFA(state, preferredTfa) {
      state.preferred_tfa = preferredTfa;
    },
    loginFailure(state) {
      state.token = null;
      state.user = null;
    },
    logout(state) {
      state.token = null;
      state.user = null;
    },
    registerSuccess(state, token) {
      state.token = token;
      state.user = parseJwt(token).sub;
    },
    registerFailure(state) {
      state.token = null;
      state.user = null;
    },
    refreshToken(state, token) {
      state.token = token;
    },
  },
};

export default auth;
